import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

//Compoments
import DashboardMenu from '../../components/dashboard/DashboardMenu';
import Header from '../../components/layouts/header';
import FormTraducoes from '../../components/forms/FormTraducoes'
import Body from '../../components/layouts/body';


class Traducoes extends React.Component {
        
    render() {
        return (
            <>            
            <DashboardMenu />
            <Header titulo="Traduções da Páginas" subtitulo="Cadastro" descricao="" />
            <Body>               
                <FormTraducoes />
            </Body>
            </>
        )
    }
}

export default connect()(withRouter(Traducoes));